<template>
  <div class="info-box">
    <div class="flex-1 gap-x-5 grid grid-cols-2 overflow-hidden">
      <div class="flex flex-col overflow-hidden">
        <div
          class="overflow-y-auto py-7 px-2.5 rounded-lg"
          style="background: linear-gradient(to bottom, #e9f4fe, #fff, #eefbf8)"
        >
          <div v-for="(item, index) in 3" :key="item" class="mb-5">
            <ul class="flex items-center gap-x-2 text-sm">
              <div class="c-icon-trigon-r" style="--size: 10"></div>
              <strong style="color: #414a96">
                {{ "DAY" + (index + 1).toString().padStart(2, "0") }}
              </strong>
              <text class="font-bold">12月21日</text>
            </ul>
            <div class="text-xs my-3 font-bold">会议大厅</div>
            <div
              style="grid-template-columns: 0.7fr 1fr"
              class="p-2 grid text-xs rounded bg-blue-100 items-center"
            >
              <li style="min-width: 0">10:00 ~ 12:00</li>
              <div class="flex gap-x-1 items-center">
                <text style="color: #063f94">●</text>
                <li
                  class="text-xs font-bold cursor-pointer"
                  style="color: #063f94"
                >
                  临床需求驱动的红细胞疾病学科创新临床研究
                </li>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col overflow-hidden">
        <strong>已选</strong>
        <div class="flex-1 overflow-y-auto flex flex-col gap-y-1 pr-3">
          <div
            v-for="item in state.select_data"
            :key="item"
            class="flex items-center p-2.5 rounded-lg gap-x-5"
          >
            <el-image
              v-if="item.avatar"
              :src="$imgUrl + item.avatar"
              class="w-10 h-10 rounded-full"
            />
            <div
              v-else
              class="w-10 h-10 rounded-full bg-gray-300 flex items-center justify-center text-white text-lg"
            >
              {{ item.name.slice(0, 1) }}
            </div>
            <div class="flex-1 shrink-0">
              <ul class="flex items-center">
                <li class="flex-1 gap-x-3 flex items-center">
                  <strong style="color: var(--el-color-primary)">
                    {{ item.name }}
                  </strong>
                  <c_sex :value="item.sex" />
                </li>
              </ul>
              <ul>
                {{
                  $phoneFormat(item.phone)
                }}
              </ul>
            </div>
            <el-input v-model="item.remark" class="!w-24" placeholder="身份" />
            <el-icon
              @click="
                state.select_data = state.select_data.filter(
                  (data) => data.id != item.id,
                )
              "
              color="#f00"
              :size="20"
              class="hover:!text-red-300 cursor-pointer"
            >
              <CircleClose />
            </el-icon>
          </div>
        </div>
      </div>
    </div>
    <div class="submit-box px-2.5">
      <el-button type="warning" size="large" @click="onSubmit">
        覆盖日程
      </el-button>
      <el-button type="primary" size="large" @click="onSubmit">
        追加日程
      </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
export default {
  setup() {
    const state = reactive({
      type: 1,
      totalCount: 100,
      params: {},
      list_data: [
        {
          id: 1,
          name: "张千惠",
          sex: "女",
          phone: "18955165014",
          pinyin: "ZHANGQIANHUI",
        },
        {
          id: 2,
          name: "徐跃",
          sex: "男",
          phone: "18955165014",
          pinyin: "XUYUE",
        },
        {
          id: 3,
          name: "刘能",
          sex: "男",
          phone: "18955165014",
          pinyin: "LIUNENG",
        },
        {
          id: 4,
          name: "二丫",
          sex: "女",
          phone: "18955165014",
          pinyin: "ERYA",
        },
        {
          id: 5,
          name: "张晓慧",
          sex: "女",
          phone: "18955165014",
          pinyin: "ZHANGXIAOHUI",
        },
        {
          id: 6,
          name: "张千惠",
          sex: "女",
          phone: "18955165014",
          pinyin: "ZHANGQIANHUI",
        },
        {
          id: 7,
          name: "徐跃",
          sex: "男",
          phone: "18955165014",
          pinyin: "XUYUE",
        },
        {
          id: 8,
          name: "刘能",
          sex: "男",
          phone: "18955165014",
          pinyin: "LIUNENG",
        },
        {
          id: 9,
          name: "二丫",
          sex: "女",
          phone: "18955165014",
          pinyin: "ERYA",
        },
        {
          id: 10,
          name: "张晓慧",
          sex: "女",
          phone: "18955165014",
          pinyin: "ZHANGXIAOHUI",
        },
      ],
      select_data: [],
    });
    onMounted(() => {});

    const onSelect = (item) => {
      if (state.select_data.some((w) => w.id == item.id)) {
        state.select_data = state.select_data.filter((w) => w.id != item.id);
      } else {
        state.select_data.push(item);
      }
    };

    return { state, onSelect };
  },
};
</script>

<style lang="less" scoped></style>
